import Grid from '@mui/material/Grid';
import { v4 as uuid } from 'uuid';

import Options from 'src/interviews/components/Options';
import { Paragraph } from 'src/interviews/components/Layout/Embedded';
import SubmitButton from 'src/interviews/components/SubmitButton';
import useChatList from '../../hooks/useChatList';
import useIntermediary from '../../hooks/useIntermediary';
import { QuestionType } from 'src/packages/polaris/types/interviews';

const Consent = () => {
  const chatList = useChatList();
  const { header, message, paragraphs, variant } = useIntermediary() || {};
  const question = {
    id: 'consent-question',
    text: '',
    index: chatList.items.length - 1,
    media: '',
    media_alttext: '',
    choice: QuestionType.Single,
    options: [
      {
        token: uuid(),
        text: 'I acknowledge that I have read and understood the above information',
        valid: true,
      },
      {
        token: uuid(),
        text: 'I have read the above information and I do not wish to continue.',
        valid: false,
      },
    ],
  };
  return (
    <Grid item>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Paragraph className="bp-pb-6">{message}</Paragraph>
          <Paragraph>{header}</Paragraph>
        </Grid>
        <Grid item>
          {paragraphs?.map((p, i) => (
            <Paragraph className="bp-pb-6" key={`paragraph-${i}`}>
              {p}
            </Paragraph>
          ))}
        </Grid>
        <Grid item>
          <Options question={question} isMultiSelect={false} showSubmitButton={false} />
        </Grid>
      </Grid>
      <SubmitButton onClick={() => {}} isIntermediary={true} />
    </Grid>
  );
};

export default Consent;
